/**
 * Product Like API
 * Server implementation is: POST /api/v1/products/{product_id}/likes, DELETE /api/v1/products/{product_id}/likes
 */

import { ApiBase } from "../../../core/api-base";

class ProductLikeApiService extends ApiBase {
    public static async addLike(productId: number): Promise<Response> {
        return await super.apiPost(`/api/v1/products/${productId}/likes`, null, { noSpinner: true });
    }

    public static async removeLike(productId: number): Promise<Response> {
        return await super.apiDelete(`/api/v1/products/${productId}/likes`, { noSpinner: true });
    }
}

export { ProductLikeApiService };
